import React from "react";
import { Alert, Snackbar } from "@mui/material";

/** Top snackbar used by showAlert. */
export default function AlertSnackbar({
  alertMessage,
  alertOpen,
  alertSeverity,
  setAlertOpen,
}) {
  return (
    <Snackbar
      className="single-product-bell-mt"
      open={alertOpen}
      autoHideDuration={6000}
      onClose={() => setAlertOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
    >
      <Alert
        onClose={() => setAlertOpen(false)}
        severity={alertSeverity}
        sx={{ width: "100%" }}
      >
        {alertMessage}
      </Alert>
    </Snackbar>
  );
}
